import { useState } from 'react';
import { Users } from 'lucide-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Lpp from "./Hublang/Loket/Lpp";
import OldLpp from "./Hublang/Loket/OldLpp";
import { Tunggakan } from "./Hublang/Penagihan/TTunggakan";
import { Perlunasan } from "./Hublang/Loket/Perlunasan";
import { Pembatalan } from "./Hublang/Loket/Pembatalan";
import Rlpp from "./Hublang/Loket/Rlpp";
import { TunggakanPiutang } from './Hublang/Penagihan/TTunggakanPiutang';
import { OldLppStatus } from './Hublang/Loket/OldLppStatus';

export default function DashboardLoket() {
  const [menuStatus, setMenuStatus] = useState("lpp");
  

  return (
    <>
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="max-w-8xl mx-auto">
          {/* Header */}
          <div className="mb-8">
            <div className="flex items-center mb-4">
              <Users className="w-8 h-8 text-blue-600 mr-3" />
              <div>
                <h1 className="text-3xl font-bold text-gray-800">Loket</h1>
                {/* <p className="text-gray-600">Kelola data karyawan dan informasi kontrak</p> */}
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0">
              <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
                <button 
                  onClick={() => setMenuStatus("lpp")}
                  className={`flex items-center px-4 py-2 text-gray-700 bg-${menuStatus === 'lpp' ? 'blue' : 'gray'}-100 rounded-lg hover:bg-${menuStatus === 'lpp' ? 'blue' : 'gray'}-200 transition-colors`}>
                  LPP
                </button>

                <button 
                  onClick={() => setMenuStatus("rlpp")}
                  className={`flex items-center px-4 py-2 text-gray-700 bg-${menuStatus === 'rlpp' ? 'blue' : 'gray'}-100 rounded-lg hover:bg-${menuStatus === 'rlpp' ? 'blue' : 'gray'}-200 transition-colors`}>
                  Rekap LPP
                </button>

                <button 
                  onClick={() => setMenuStatus("pemakaian")}
                  className={`flex items-center px-4 py-2 text-gray-700 bg-${menuStatus === 'pemakaian' ? 'blue' : 'gray'}-100 rounded-lg hover:bg-${menuStatus === 'pemakaian' ? 'blue' : 'gray'}-200 transition-colors`}>
                  Piutang - Tatiye
                </button>

                <button
                  onClick={() => setMenuStatus("OldLppStatus")}
                  className={`flex items-center px-4 py-2 text-gray-700 bg-${menuStatus === 'OldLppStatus' ? 'blue' : 'gray'}-100 rounded-lg hover:bg-${menuStatus === 'OldLppStatus' ? 'blue' : 'gray'}-200 transition-colors`}>
                  Piutang per Status
                </button>

                {/* <button 
                  onClick={() => setMenuStatus("pemakaian-piutang")}
                  className={`flex items-center px-4 py-2 text-gray-700 bg-${menuStatus === 'rlpp' ? 'blue' : 'gray'}-100 rounded-lg hover:bg-${menuStatus === 'rlpp' ? 'blue' : 'gray'}-200 transition-colors`}>
                  Pemakaian - Tatiye (piutang)
                </button> */}

                {/* <button 
                  onClick={() => setMenuStatus("oldlpp")}
                  className={`flex items-center px-4 py-2 text-gray-700 bg-${menuStatus === 'oldlpp' ? 'blue' : 'gray'}-100 rounded-lg hover:bg-${menuStatus === 'oldlpp' ? 'blue' : 'gray'}-200 transition-colors`}>
                  LPP - Update Sebelumnya
                </button> */}
              </div>
            </div>
          </div>

          { menuStatus == "lpp" && <Lpp />}
          {/* { menuStatus == "tunggakan" && <Tunggakan />}
          { menuStatus == "perlunasan" && <Perlunasan />}
          { menuStatus == "pembatalan" && <Pembatalan />} */}
          { menuStatus == "rlpp" && <Rlpp />}
          { menuStatus == "pemakaian" && <Tunggakan />}
          { menuStatus == "pemakaian-piutang" && <TunggakanPiutang />}
          { menuStatus == "OldLppStatus" && <OldLppStatus /> }
          {/* { menuStatus == "oldlpp" && <OldLpp />} */}


        </div>
      </div>
    </>
  )
}
